/**
 * Edit-tool identifiers and pure helpers for the Editor title-bar tool strip.
 */
export const EDIT_TOOL_ICONS = {
    text: 'title',
    select: 'arrow_selector_tool',
    pen: 'draw',
    insert: 'add',
    convert: 'gesture',
    cut: 'content_cut'
};
export const STICKY_EDIT_TOOLS = [
    'select',
    'pen',
    'insert',
    'convert',
    'cut'
];
export function resolveHighlightedEditTool(options) {
    if (!options.isEditMode) {
        return 'text';
    }
    if (options.altKeyPressed && !options.cmdKeyPressed) {
        return 'convert';
    }
    if (options.cmdKeyPressed && !options.altKeyPressed) {
        return options.hasAddPointPreview ? 'insert' : 'pen';
    }
    return options.stickyTool;
}
export function resolvePointerBadgeTool(highlightedTool) {
    if (highlightedTool === 'insert' ||
        highlightedTool === 'convert' ||
        highlightedTool === 'cut') {
        return highlightedTool;
    }
    return null;
}
export function resolvePointerBadge(options) {
    if (options.cmdKeyPressed && options.hoveringCuttableNode) {
        return 'cut';
    }
    return resolvePointerBadgeTool(options.highlightedTool);
}
export function chooseDefaultStickyEditTool(_availability) {
    return 'select';
}
export function ensureStickyEditToolAvailable(stickyTool, availability) {
    if (availability[stickyTool]) {
        return stickyTool;
    }
    return 'select';
}
export function shortcutKeyToStickyEditTool(key) {
    switch (key.toLowerCase()) {
        case 't':
            return 'text';
        case 'v':
            return 'select';
        case 'p':
            return 'pen';
        case 'i':
            return 'insert';
        case 'c':
            return 'convert';
        default:
            return null;
    }
}
